import { render, staticRenderFns } from "./relevance-form-dropdown.vue?vue&type=template&id=4abc2453"
import script from "./relevance-form-dropdown.vue?vue&type=script&lang=ts"
export * from "./relevance-form-dropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports